const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:4000";

export interface SurelcLoginPayload {
  acsUrl: string;
  samlResponse: string;
  relayState: string;
}

export async function requestSurelcLogin(
  token: string,
  body: { samlRequest?: string; relayState?: string; binding?: "post" | "redirect" } = {}
): Promise<SurelcLoginPayload> {
  const response = await fetch(`${API_BASE}/api/surelc/sso`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const json = await response.json().catch(() => null);
  if (!response.ok || !json?.success || !json.data?.acsUrl || !json.data?.samlResponse) {
    throw new Error(json?.error || "Unable to open SureLC");
  }
  return {
    acsUrl: String(json.data.acsUrl),
    samlResponse: String(json.data.samlResponse),
    relayState: String(json.data.relayState ?? ""),
  };
}

export function submitSurelcForm(target: Window, login: SurelcLoginPayload) {
  let acs: URL;
  try {
    acs = new URL(login.acsUrl);
  } catch {
    throw new Error("SureLC login URL is invalid.");
  }
  if (acs.protocol !== "https:") {
    throw new Error("SureLC login URL must use HTTPS.");
  }
  if (!/^[A-Za-z0-9+/=\s]+$/.test(login.samlResponse)) {
    throw new Error("SureLC login response was not valid.");
  }
  const relayState = login.relayState.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "");
  target.document.open();
  target.document.write(`<!doctype html><html><body>
    <p>Opening SureLC…</p>
    <form id="surelc-sso" method="post" action="${acs.toString().replace(/"/g, "&quot;")}">
      <input type="hidden" name="SAMLResponse" value="${login.samlResponse}" />
      <input type="hidden" name="RelayState" value="${relayState}" />
    </form>
    <script>document.getElementById("surelc-sso").submit();</script>
  </body></html>`);
  target.document.close();
}
